module.exports = __webpack_public_path__ + "media/images/welcome_relational_enneagram-25dcaaa5964dc3597e95bcb2a3f616f9.svg";